<template>
    <div class="page bg-fff">
        <backTitleBar></backTitleBar>
        <div class="page-content">
            <div class="notice-title">{{entity.title}}</div>
            <div class="fs-28 color-999 mt-15">{{entity.createTime}}</div>
            <div class="mt-30 fs-32 color-333">{{entity.content}}</div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {getMsgNoticeDetail} from "@/api/msg"
    export default {
        name: "noticeDetail",
        components:{backTitleBar},
        data(){
            return{
                entity:{},
                noticeId:''
            }
        },
        methods:{
            getDetail(){
                let params = {
                    noticeId: this.noticeId
                }
                getMsgNoticeDetail(params).then(res=>{
                    this.entity = res.data
                })
            }
        },
        created() {
            this.noticeId = this.$route.query.noticeId;
            this.getDetail()
        }

    }
</script>

<style scoped lang="scss">
    .page-content{
        padding: .24rem;
        .notice-title{
            font-size: .42rem;
            line-height: .54rem;
            color: #333;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// noticeDetail.vue?4c9eb7f5